import { Order } from "domains/order/agreggates/order/Order";
import { OrderComposition } from "domains/order/agreggates/order/OrderComposition";
import { OrderCompositionItem } from "domains/order/agreggates/order/OrderCompositionItem";
import { FinancialTransactionModel } from "domains/order/agreggates/payment/FinancialTransactionModel";
import { TransactionType } from "domains/order/agreggates/payment/transactionType";
import moment from "moment";
import { v4 } from "uuid";
import {
  OpcaoDoConsumidor,
  OpcoesDoConsumidor,
  PedidoPos,
  ProdutoPedidoPos,
  ClienteEstabelecimento,
  StatusPedido,
  DadosConsumoPOS,
  ConsumoItemPedido,
  ConsumoAdicionais,
  ConsumoObservacoes,
  ProdutoTipo,
  ConsumoPedidoPos,
} from "../../interfaces/PedidoMeep";

export const orderCompositionItensToOpcoes = (
  orderCompositionItens: OrderCompositionItem[]
) => {
  const newOpcoes = orderCompositionItens.map<OpcaoDoConsumidor>(
    (orderCompositionItem) => ({
      id: orderCompositionItem.compositionItemId ?? v4(),
      produtoId: orderCompositionItem.productId,
      descricao: orderCompositionItem.description,
      isChecked: orderCompositionItem.quantity > 0,
      quantidade: orderCompositionItem.quantity,
      quantidadeGratuitoSelecionado: orderCompositionItem.quantityFreeSelected,
      produtoValor: orderCompositionItem.price,
      quantidadeGratuito: orderCompositionItem.quantityFree,
      isProductGeneralObservation:
        orderCompositionItem.isProductGeneralObservation,
    })
  );

  return newOpcoes;
};

const sumOpcoesDoConsumidorValue = (
  opcoesDoConsumidor: OpcoesDoConsumidor[]
) =>
  opcoesDoConsumidor.reduce((total, opcao) => {
    const additionalsValue = opcao.opcoes.reduce((acc, o) => {
      if (!o.isChecked || o.isProductGeneralObservation) return acc;
      return acc + o.produtoValor * o.quantidade - o.quantidadeGratuito * o.produtoValor;
    }, 0);
    return total + additionalsValue;
  }, 0);

export const orderCompositionToOpcoesDoConsumidor = (
  orderComposition: OrderComposition[]
) => {
  const newOpcoesDoConsumidor: OpcoesDoConsumidor[] =
    orderComposition.map<OpcoesDoConsumidor>((orderComposition) => {
      const newOpcoes = orderCompositionItensToOpcoes(
        orderComposition.orderCompositionItems
      );
      return {
        id: orderComposition.compositionId,
        descricao: orderComposition.description,
        opcoes: newOpcoes,
      };
    });
  return newOpcoesDoConsumidor;
};

export const orderToPedidoPOS = (
  order: Order,
  tipoPagamento?: TransactionType,
  transacaoAdquirente?: FinancialTransactionModel
): PedidoPos => {
  const newProdutos: ProdutoPedidoPos[] = [];

  order.orderItems.forEach((orderItem) => {
    const constNewOpcoesConsumidor = orderCompositionToOpcoesDoConsumidor(
      orderItem.orderComposition ?? []
    );


    console.log("orderItem:", orderItem);


    const additionalsValue = sumOpcoesDoConsumidorValue(
      constNewOpcoesConsumidor
    );

    const isProductGranel = orderItem.isWeight;
    if (!isProductGranel) {
      for (let index = 0; index < orderItem.quantity; index++) {
        const itemWithDiscount =
          orderItem?.discountQuantity && index < orderItem.discountQuantity;
        newProdutos.push({
          nome: orderItem.name ?? "",
          nomeProduto: orderItem.name ?? "",
          ticketId: v4(),
          tipoProduto: orderItem.productType,
          produtoId: orderItem.productId,
          valor:
            (itemWithDiscount
              ? orderItem.productPrice - (orderItem?.unitDiscount ?? 0)
              : orderItem.realPrice) + additionalsValue, //total product price para Kg e real price pro resto, incluindo adicionais
          opcoesDoConsumidor: JSON.stringify(constNewOpcoesConsumidor),
          opcoesDoConsumidorObject: constNewOpcoesConsumidor,
          category: orderItem?.category,
          storeName: orderItem.storeName,
          impressora: orderItem.printerName,
          regraListaDescontoId: itemWithDiscount
            ? orderItem?.discountId
            : undefined,
          valorSemDesconto: itemWithDiscount ? orderItem.totalPrice : undefined,
          desconto: itemWithDiscount ? orderItem?.unitDiscount : undefined,
        });
      }
    } else {
      newProdutos.push({
        nome: orderItem.name ?? "",
        nomeProduto: orderItem.name ?? "",
        ticketId: v4(),
        tipoProduto: orderItem.productType,
        produtoId: orderItem.productId,
        valor: orderItem.realPrice + additionalsValue,
        opcoesDoConsumidor: JSON.stringify(constNewOpcoesConsumidor),
        opcoesDoConsumidorObject: constNewOpcoesConsumidor,
        category: orderItem?.category,
        quantidade: orderItem.quantity,
        storeName: orderItem.storeName,
        impressora: orderItem.printerName,
        desconto: orderItem.discount,
      });
    }
  });

  const clienteEstabelecimento: ClienteEstabelecimento = {
    nome: order.customer?.name,
    identificador: order?.customer?.clientIdentificator,
    cpf: order.customer?.document,
    telefone: order.customer?.phone,
    email: order.customer?.email,
    comanda: order.customer?.orderPad,
    mesa: order.customer?.prism,
    pedidoPosPaiId: order.customer?.associationId,
    pedidoPosId: order.customer?.orderId,
    tag: order.customer?.tag,
  };

  const dadosTransacao =
    tipoPagamento === TransactionType.pix && order?.paymentPix
      ? JSON.stringify(order.paymentPix)
      : tipoPagamento === TransactionType.wallet && order?.paymentWallet
        ? JSON.stringify(order.paymentWallet)
        : transacaoAdquirente
          ? JSON.stringify(transacaoAdquirente)
          : "";

  const newPedidoPos: PedidoPos = {
    codigoPedido: order.friendlyId,
    tipoPagamento: tipoPagamento, //Enum tipo de pagamento 1=credito 2=debito
    pedidoPOSId: order.id, //Guid Gerado no totem
    statusPedido:
      transacaoAdquirente?.Status === StatusPedido.AguardandoPagamento
        ? StatusPedido.AguardandoPagamento
        : tipoPagamento === TransactionType.pospaid
          ? StatusPedido.Pendente
          : StatusPedido.Aprovado, // 3 pagamento realizado
    tipoAdquirente:
      transacaoAdquirente?.TipoAdquirente &&
        transacaoAdquirente?.TipoAdquirente !== 1
        ? transacaoAdquirente.TipoAdquirente
        : 6, //6=cielo
    dataPedido: moment.utc().toDate(), //UTC
    dadosTransacao,
    dadosTransacaoObject: transacaoAdquirente,
    produtos: JSON.stringify(newProdutos),
    produtosObject: newProdutos,
    valorTotal: order.totalValue,
    pedidoPOSPaiId: order.customer?.associationId,
    tagCashless: order.customer?.tag ?? "",
    clienteEstabelecimento: JSON.stringify(clienteEstabelecimento),
    clienteEstabelecimentoObject: clienteEstabelecimento,
    observacaoPedido: order.observation,
    codigoPainelSenha: order.passwordPanelCode,
    sincronized: "isDataRecorded" in order ? order.isDataRecorded : null,
    isOfflineRecharge: order?.isOfflineRecharge,
    isOfflineRechargeRecordConfirmed: order?.isOfflineRechargeRecordConfirmed,
    superAppEventId: order.superAppEventId || '',
    ...(order.registroSessaoPOSId
      ? { registroSessaoPOSId: order.registroSessaoPOSId }
      : {}),
    ...(order.currentSessionId
      ? { currentSessionId: order.currentSessionId }
      : {}),
    activationValue: order.activationValue,
    sectionKey: order.sectionKey,
    isClosed: order.isClosed,
  };

  return newPedidoPos;
};

export const orderToConsusmeOrder = (
  pedidoPos: PedidoPos,
  localId: string,
  equipamentId?: string
): DadosConsumoPOS => {
  let consumoPos: DadosConsumoPOS;
  let items: ConsumoItemPedido[] = [];
  let annotation: string = "";

  pedidoPos.produtosObject.forEach((it) => {
    let additionals: ConsumoAdicionais[] = [];
    let observations: ConsumoObservacoes[] = [];

    it.opcoesDoConsumidorObject.forEach((op) => {
      const isAdditional = op.opcoes.every((o) => o.produtoId);
      if (isAdditional) {
        op.opcoes.forEach((opcao) => {
          additionals.push({
            productId: opcao.produtoId ?? opcao.id,
            selectedQuantity: opcao.quantidade,
            unitValue: opcao.produtoValor,
            discountValue: opcao.quantidadeGratuito * opcao.produtoValor,
          });
        });
      } else {
        op.opcoes.forEach((opcao) => {
          const obs = {
            id: opcao.id,
            question: op.descricao,
            answer: opcao.descricao,
          };
          if (obs.answer && !opcao.isProductGeneralObservation) {
            observations.push(obs);
          } else if (opcao.isProductGeneralObservation) {
            annotation = obs.answer;
          }
        });
      }
    });

    // it.valor já inclui o valor dos adicionais (ver orderToPedidoPOS), então
    // não soma additionals aqui de novo para não duplicar o valor.
    const totalValue = it.valor;

    const item = {
      ticketsIds: [it.ticketId],
      productId: it.produtoId,
      productName: it.nomeProduto,
      // `it.valor` já vem com o desconto subtraído em orderToPedidoPOS,
      // por isso não se desconta de novo aqui.
      unitValue: totalValue,
      discountValue: 0,
      quantity: it.quantidade ?? 1,
      annotation,
      additionals,
      observations,
      optionsOldFormat: "",
      productType: it.tipoProduto,
    };

    const index = items.findIndex((i) => {
      const findString =
        (i.productId ?? "") +
        i.unitValue +
        JSON.stringify(i.additionals) +
        JSON.stringify(i.observations);
      const itemString =
        (it.produtoId ?? "") +
        it.valor +
        JSON.stringify(additionals) +
        JSON.stringify(observations);
      return findString === itemString;
    });

    if ((index >= 0 || items[index]) && it.tipoProduto !== ProdutoTipo.Kilo) {
      items[index].quantity += 1;
      items[index].ticketsIds.push(it.ticketId);
    } else {
      //Não sincronizar taxa de serviço no consumo pós pago
      if (item.productType !== ProdutoTipo.TaxaServico) {
        items.push(item);
      }
    }
  });

  let _order: ConsumoPedidoPos = {
    orderId: pedidoPos.pedidoPOSId,
    createdAt: pedidoPos.dataPedido,
    descriptionPersonalizedDelivery:
      pedidoPos.clienteEstabelecimentoObject.mesa,
    items,
  };

  consumoPos = {
    localId: localId,
    accountId: pedidoPos.pedidoPOSPaiId ?? "",
    equipamentId: equipamentId ?? "",
    order: _order,
  };

  return consumoPos;
};

export const pedidoPosToLog = (order: PedidoPos[]) => {
  return order.map((it) => ({
    pedidoPOSId: it.pedidoPOSId,
    pedidoPOSPaiId: it.pedidoPOSPaiId,
    valorTotal: it.valorTotal,
    tipoPagamento: it.tipoPagamento,
    produtos: it.produtos,
    dadosTransacao: it.dadosTransacao,
    tagCashless: it.tagCashless,
  }));
};

export const consumeOrderToLog = (consumoPos: DadosConsumoPOS) => {
  return {
    accountId: consumoPos.accountId,
    orderId: consumoPos.order.orderId,
    items: consumoPos.order.items,
  };
};
